.root {
  display: flex;
  overflow: hidden;
}

.grid {
  z-index: 0; /* STACKING CONTEXT */
  display: grid;
  grid-template-areas: 'colHeaders colHeaders' 'rowHeaders grid';
  grid-template-columns: min-content 1fr;
  grid-template-rows: min-content 1fr;
  color: var(--h5w-matrix--color, inherit);
  font-family: var(--h5w-matrix--fontFamily, monospace);
  font-size: var(--h5w-matrix--fontSize, inherit);
  scrollbar-width: thin;
}

/* Grid sizing element */
.grid > :last-child {
  grid-area: grid;
}

.colHeaders {
  grid-area: colHeaders;
  position: sticky;
  top: 0;
  z-index: 2; /* above row header cells and content cells */
  display: flex;
}

.rowHeaders {
  grid-area: rowHeaders;
  position: sticky;
  left: 0;
  z-index: 1; /* above content cells */
  display: flex;
  flex-direction: column;
}

.indexCell {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--h5w-matrix-indexCell--bgColor, #eee);
  color: var(--h5w-matrix-indexCell--color, var(--h5w-matrix--color, inherit));
  font-family: var(
    --h5w-matrix-indexCell--fontFamily,
    var(--h5w-matrix--fontFamily, monospace)
  );
  font-size: var(
    --h5w-matrix-indexCell--fontSize,
    var(--h5w-matrix--fontSize, inherit)
  );
  font-weight: var(--h5w-matrix-indexCell--fontWeight, 600);
}

.indexCell[data-bg] {
  background-color: var(--h5w-matrix-indexCell--bgColorAlt, lightgray);
}

.topLeftCell {
  composes: indexCell;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 1; /* above column header cells */
}

.dataCell {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--h5w-matrix-cell--bgColor, transparent);
  overflow: hidden;
  white-space: nowrap;
}

.dataCell[data-bg] {
  background-color: var(--h5w-matrix-cell--bgColorAlt, #eee);
}
